module.exports = __webpack_public_path__ + "img/symbol_10.3414ab4a.png";